/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  DeleteAdminV1StoresStoreIdShippingRatesIdPathParameters,
  DeleteAdminV1StoresStoreIdShippingZonesIdPathParameters,
  GetAdminV1StoresStoreIdShippingZones200,
  GetAdminV1StoresStoreIdShippingZonesPathParameters,
  PatchAdminV1StoresStoreIdShippingRatesIdBody,
  PatchAdminV1StoresStoreIdShippingRatesIdPathParameters,
  PatchAdminV1StoresStoreIdShippingZonesIdBody,
  PatchAdminV1StoresStoreIdShippingZonesIdPathParameters,
  PostAdminV1StoresStoreIdShippingZonesBody,
  PostAdminV1StoresStoreIdShippingZonesIdRatesBody,
  PostAdminV1StoresStoreIdShippingZonesIdRatesPathParameters,
  PostAdminV1StoresStoreIdShippingZonesPathParameters,
  ShippingRate,
  ShippingZone
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Shipping zones with their rates
 */
export const getAdminV1StoresStoreIdShippingZones = (
    { storeId }: GetAdminV1StoresStoreIdShippingZonesPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdShippingZones200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdShippingZones200>(
      {url: `/admin/v1/stores/${storeId}/shipping-zones`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Add a zone
 */
export const postAdminV1StoresStoreIdShippingZones = (
    { storeId }: PostAdminV1StoresStoreIdShippingZonesPathParameters,
    postAdminV1StoresStoreIdShippingZonesBody: BodyType<PostAdminV1StoresStoreIdShippingZonesBody>,
 options?: SecondParameter<typeof customInstance<ShippingZone>>,) => {
      return customInstance<ShippingZone>(
      {url: `/admin/v1/stores/${storeId}/shipping-zones`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdShippingZonesBody
    },
      options);
    }
  /**
 * @summary Update a zone
 */
export const patchAdminV1StoresStoreIdShippingZonesId = (
    { storeId, id }: PatchAdminV1StoresStoreIdShippingZonesIdPathParameters,
    patchAdminV1StoresStoreIdShippingZonesIdBody: BodyType<PatchAdminV1StoresStoreIdShippingZonesIdBody>,
 options?: SecondParameter<typeof customInstance<ShippingZone>>,) => {
      return customInstance<ShippingZone>(
      {url: `/admin/v1/stores/${storeId}/shipping-zones/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdShippingZonesIdBody
    },
      options);
    }
  /**
 * @summary Delete a zone and its rates
 */
export const deleteAdminV1StoresStoreIdShippingZonesId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdShippingZonesIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/shipping-zones/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * flat: fixed price; weight and price: banded by weight or subtotal; free_over: free above minSubtotal
 * @summary Add a rate to a zone
 */
export const postAdminV1StoresStoreIdShippingZonesIdRates = (
    { storeId, id }: PostAdminV1StoresStoreIdShippingZonesIdRatesPathParameters,
    postAdminV1StoresStoreIdShippingZonesIdRatesBody: BodyType<PostAdminV1StoresStoreIdShippingZonesIdRatesBody>,
 options?: SecondParameter<typeof customInstance<ShippingRate>>,) => {
      return customInstance<ShippingRate>(
      {url: `/admin/v1/stores/${storeId}/shipping-zones/${id}/rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdShippingZonesIdRatesBody
    },
      options);
    }
  /**
 * @summary Update a rate
 */
export const patchAdminV1StoresStoreIdShippingRatesId = (
    { storeId, id }: PatchAdminV1StoresStoreIdShippingRatesIdPathParameters,
    patchAdminV1StoresStoreIdShippingRatesIdBody: BodyType<PatchAdminV1StoresStoreIdShippingRatesIdBody>,
 options?: SecondParameter<typeof customInstance<ShippingRate>>,) => {
      return customInstance<ShippingRate>(
      {url: `/admin/v1/stores/${storeId}/shipping-rates/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdShippingRatesIdBody
    },
      options);
    }
  /**
 * @summary Delete a rate
 */
export const deleteAdminV1StoresStoreIdShippingRatesId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdShippingRatesIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/shipping-rates/${id}`, method: 'DELETE'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdShippingZonesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdShippingZones>>>
export type PostAdminV1StoresStoreIdShippingZonesResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdShippingZones>>>
export type PatchAdminV1StoresStoreIdShippingZonesIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdShippingZonesId>>>
export type DeleteAdminV1StoresStoreIdShippingZonesIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdShippingZonesId>>>
export type PostAdminV1StoresStoreIdShippingZonesIdRatesResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdShippingZonesIdRates>>>
export type PatchAdminV1StoresStoreIdShippingRatesIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdShippingRatesId>>>
export type DeleteAdminV1StoresStoreIdShippingRatesIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdShippingRatesId>>>
